import { render, staticRenderFns } from "./PrelitLegalModal.vue?vue&type=template&id=59d4d533"
import script from "./PrelitLegalModal.vue?vue&type=script&lang=js"
export * from "./PrelitLegalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports